import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { Trustpilot } from '@carbonify/ui';
import useConfig from 'services/config';

interface TrustpilotBlockRecord extends CdaStructuredTextRecord {
  templateId: string;
  businessUnitId: string;
  theme?: 'light' | 'dark';
}

export default function TrustpilotBlock({ templateId, businessUnitId, theme = 'light' }: TrustpilotBlockRecord) {
  const { locale } = useConfig();
  return (
    <Trustpilot
      templateId={templateId}
      businessUnitId={businessUnitId}
      theme={theme}
      locale={locale}
    />
  );
}
